import { createReducer } from '@reduxjs/toolkit'
import { Actions_MeUser } from './Actions'
import { IStateMeUser } from './TReducer'

const initialState: IStateMeUser = {
  isLoading: false,
  data: null,
  responseInfo: null,
}

const ReducerMeUser = createReducer(initialState, (builder) => {
  builder
    .addCase(Actions_MeUser.store.showLoader, (state) => {
      state.isLoading = true
    })
    .addCase(Actions_MeUser.store.hideLoader, (state) => {
      state.isLoading = false
    })
    .addCase(Actions_MeUser.store.saveMeUser, (state, action) => {
      const payload = action.payload
      return { ...state, ...payload }
    })
    .addCase(Actions_MeUser.store.clearMeUser, (state) => {
      state.data = null
    })
})

export default ReducerMeUser
